var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{attrs:{"id":"get-paginated-data"}},[_vm._t("default",null,{"entries":_vm.entries,"count":_vm.count}),_c('v-paginator',{attrs:{"resource_url":_vm.resource_url,"config":""},on:{"update":_vm.updateResource}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }